interface Props {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  hint?: string;
}

export function PeopleSelector({ value, onChange, min = 1, max = 20, hint }: Props) {
  const safeMax = Math.max(min, max);
  const dec = () => value > min && onChange(value - 1);
  const inc = () => value < safeMax && onChange(value + 1);
  return (
    <div className="field">
      <span>Pessoas</span>
      <div className="stepper">
        <button type="button" onClick={dec} aria-label="Menos" disabled={value <= min}>
          −
        </button>
        <output>{value}</output>
        <button type="button" onClick={inc} aria-label="Mais" disabled={value >= safeMax}>
          +
        </button>
      </div>
      {hint && <small className="field__hint">{hint}</small>}
    </div>
  );
}
